import React from 'react';

const Contact = () => {
    return (
        <div>
            <h1>Contact Coming soon.......</h1>
        </div>
    );
};

export default Contact;